import { render, staticRenderFns } from "./StatisticsByCountry.vue?vue&type=template&id=4b699c8b&scoped=true&"
import script from "./StatisticsByCountry.vue?vue&type=script&lang=js&"
export * from "./StatisticsByCountry.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsByCountry.vue?vue&type=style&index=0&id=4b699c8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b699c8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
